import { router, useLocalSearchParams } from 'expo-router';
import { ScrollView, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useOnBoarding } from '@/api/hooks/meHooks';
import BrandedButton from '@/components/buttons/BrandedButton';
import PreferencesForm from '@/components/forms/PreferencesForm';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { InterestsData } from '@/lib/validations/AuthSchema';
import { i18n } from '@/utils/i18n';

const InterestsScreen = () => {
  const colors = useColor();
  const { onBoardingId, buyingShow } = useLocalSearchParams<{ onBoardingId: string; buyingShow: string }>();
  const { mutateAsync: onBoardingUpdate, isPending } = useOnBoarding();

  const titleText = i18n.t('sign_in.individual.interests.title');
  const descriptionText = i18n.t('sign_in.individual.interests.description');
  const skipButtonText = i18n.t('mix.set_up_later');

  const defaultValues = {
    denominations: [],
    religions: [],
    programs: [],
    checkbox_selection: undefined
  };

  const onSubmit = async (data: InterestsData) => {
    onBoardingUpdate(
      {
        onBoardingId: onBoardingId,
        userInterestOnReligion: data.religions,
        userInterestOnDenomination: data.denominations,
        userInterestOnProgram: data.programs,
        skipPreferenceScreen: false
      },
      {
        onSuccess: () => {
          router.replace({ pathname: '/login/individual/eula', params: { onBoardingId: onBoardingId, buyingShow } });
        }
      }
    );
  };

  const onPressSkip = () => {
    onBoardingUpdate(
      { onBoardingId: onBoardingId, skipPreferenceScreen: true },
      {
        onSuccess: () => {
          router.replace({ pathname: '/login/individual/eula', params: { onBoardingId: onBoardingId, buyingShow } });
        }
      }
    );
  };

  return (
    <SafeAreaView style={styles.contentWrapper}>
      <ScrollView contentContainerStyle={styles.scrollContainer} showsVerticalScrollIndicator={false}>
        <View style={styles.contentWrapper}>
          <View style={styles.formContainer}>
            <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
              {titleText}
            </Text>
            <Text style={[styles.descriptionText, { color: colors.titleText }]}>{descriptionText}</Text>
            <PreferencesForm defaultValues={defaultValues} onDone={onSubmit} isPending={isPending} />
          </View>
          <BrandedButton
            loading={isPending}
            style={styles.btnStyle}
            textStyles={styles.btnText}
            onPress={onPressSkip}
            fontWeight="450">
            {skipButtonText}
          </BrandedButton>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default InterestsScreen;

const styles = StyleSheet.create({
  contentWrapper: {
    flex: 1
  },

  scrollContainer: {
    paddingHorizontal: 16,
    flexGrow: 1
  },

  titleText: {
    fontSize: 22,
    marginBottom: 25,
    textAlign: 'center',
    marginTop: 18
  },

  descriptionText: {
    fontSize: 14,
    marginBottom: 25
  },

  formContainer: {
    rowGap: 16,
    flex: 1,
    marginBottom: 20
  },

  btnStyle: {
    width: '100%',
    backgroundColor: 'transparent'
  },

  btnText: {
    color: '#00000099',
    fontSize: 14
  }
});
